import './App.css';
import React from 'react';
import {AppRouter} from './components/Routes/AppRouter';
import Authorization from "./pages/Authorization";
import {useAuthStore} from "./store/AuthStore";
import {shallow} from "zustand/shallow";


function App() {
    const [authorized] = useAuthStore(s => [s.authorized], shallow);

    return (
        <>
            {
                authorized ? <AppRouter /> : <Authorization />
            }
        </>
    )

}

export default App;
